<script setup lang="ts">
import { computed } from 'vue';
import Button from '@/components/ui/button/Button.vue';
import { ClockIcon } from '@heroicons/vue/24/outline';
import { useAuthStore } from '@/stores/authStore';
import { useHistoryInspector } from '@/composables/useHistoryInspector';

/**
 * Toolbar button that opens the History Inspector seeded to the current
 * user's recent track actions (SAU-138). Lives left of a page's controls.
 */
const authStore = useAuthStore();
const { openUserHistory } = useHistoryInspector();

const userId = computed(() => authStore.userData?.id ?? null);

function openHistory() {
  if (userId.value != null) {
    openUserHistory(userId.value);
  }
}
</script>

<template>
  <Button
    variant="toolbar"
    size="sm"
    class="px-2"
    data-testid="history-button"
    aria-label="Your track history"
    :disabled="userId == null"
    @click="openHistory"
  >
    <ClockIcon class="size-4 shrink-0" />
  </Button>
</template>
